import axios from "axios";
import filter from 'lodash/filter';
import findLodash from 'lodash/find';
import assign from 'lodash/assign';
// import _ from "lodash"

// Resolved once at module load time, before Vue mounts.
// This ensures the very first render already has the correct view_mode and
// appSection, avoiding a one-tick flash where Center.vue (prematch widgets)
// mounts and fires API calls before BetConsole.vue's mounted() can correct it.
const _openLive = window.openlivesection === 'true' || window.openlivesection === true;

const state = {
    loading_general: false,
    // 'detail' = live section  |  'preview' = prematch section
    // Other values: 'result', 'printodds', 'qBet', 'list_events_day'
    view_mode: _openLive ? 'detail' : 'preview',
    loading: false,
    subaction: 'home',
    // Explicit section reference: 'live' | 'prematch'
    // Stays stable across sub-view changes (e.g. opening a result tab stays 'prematch').
    // Useful for components that need to know the current section without relying
    // on view_mode semantics.
    appSection: _openLive ? 'live' : 'prematch',
    eventViewMode: 'compact', // 'compact' | 'extended' — overwritten by applySkinSettings after API load
    accordionDetailActive: false,
};

const getters = {
    getLoadingGeneral: state => state.loading_general,
    getViewMode:       state => state.view_mode,
    getSubaction:      state => state.subaction,
    // 'live' | 'prematch'
    getAppSection:     state => state.appSection,
    getEventViewMode:  state => state.eventViewMode,
    getAccordionDetailActive: state => state.accordionDetailActive,
};

const actions = {
    async setLoadingGeneral(context, payload) {
        context.commit('SET_LOADING_GENERAL', payload.status)
    },

    async setViewMode(context, payload) {
        // Salva la posizione corrente in history quando l'utente entra nella live list.
        // skipHistory: true viene passato dai path di restauro (goBack, boot, slug restore).
        if (payload.mode === 'detail' && payload.section === 'live' && !payload.skipHistory) {
            await context.dispatch('sportNavigation/pushHistory', null, { root: true });
        }
        if (payload.mode === 'preview') {
            context.commit('detailLive/SET_EVENT_LIVE_DETAIL', [], { root: true })
            context.commit('detailLive/SET_EVENTS_LIVE_DETAIL_ACTIVE', [], { root: true })
            context.commit('SET_APP_SECTION', 'prematch')
        }

        // appSection viene impostato a 'live' SOLO quando il chiamante passa section:'live'
        // (es. goLive, boot live). Aprire un singolo evento live da prematch (overlay)
        // non deve cambiare il contesto di sezione per evitare flash visivi.
        if (payload.section === 'live') {
            context.commit('SET_APP_SECTION', 'live')
        }
        context.commit('SET_VIEW_MODE', payload.mode)

        // Notify the host skin that viewMode changed.
        // Only fires when embedded inside an iframe (window.parent !== window).
        if (typeof window !== 'undefined' && window.parent !== window) {
            window.parent.postMessage({
                type: 'VIEW_MODE_CHANGED',
                payload: { viewMode: payload.mode },
            }, '*')
        }
    },

    async setSubaction(context, payload) {
        context.commit('SET_SUBACTION', payload)
    },
    setEventViewMode({ commit }, mode) {
        commit('SET_EVENT_VIEW_MODE', mode)
    },
    setAccordionDetailActive({ commit }, val) {
        commit('SET_ACCORDION_DETAIL_ACTIVE', val)
    },
};

const mutations = {
    SET_LOADING_GENERAL(state, payload) {
        state.loading_general = !!payload
    },
    SET_VIEW_MODE(state, payload) {
        state.view_mode = payload
    },
    SET_SUBACTION(state, payload) {
        state.subaction = payload
    },
    SET_APP_SECTION(state, section) {
        state.appSection = section
    },
    SET_EVENT_VIEW_MODE(state, mode) {
        state.eventViewMode = mode
    },
    SET_ACCORDION_DETAIL_ACTIVE(state, val) {
        state.accordionDetailActive = !!val
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
